export const graph_data = [
  {
    "data": [
      {
        "name": "Enrollment - Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [5, 6, 7, 8],
        "type": "bar"
      },
      {
        "name": "No Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [30, 41, 74, 72],
        "type": "bar"
      },
      {
        "name": "Start-up Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [8, 14, 22, 12],
        "type": "bar"
      },
      { "name": "Enrollment - Risk", "x": ["Completed"], "y": [1], "type": "bar" }
    ]
  },
  {
    "data": [
      {
        "name": "Enrollment - Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [5, 6, 7, 8],
        "type": "line"
      },
      {
        "name": "No Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [30, 41, 74, 72],
        "type": "line"
      },
      {
        "name": "Start-up Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [8, 14, 22, 12],
        "type": "line"
      },
      { "name": "Enrollment - Risk", "x": ["Completed"], "y": [1], "type": "line" }
    ]
  }, {
    "data": [
      {
        "labels": ["Completed", "Delayed", "On Track", "Started"],
        "values": [5, 6, 7, 8],
        "type": "pie"
      }
    ]
  },
  {
    "data": [
      {
        "name": "Enrollment - Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [5, 6, 7, 8],
        "type": "bar"
      },
      {
        "name": "No Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [30, 41, 74, 72],
        "type": "bar"
      },
      {
        "name": "Start-up Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [8, 14, 22, 12],
        "type": "bar"
      },
      { "name": "Enrollment - Risk", "x": ["Completed"], "y": [1], "type": "bar" }
    ]
  }, {
    "data": [
      {
        "name": "Enrollment - Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [5, 6, 7, 8],
        "mode": "markers",
        "type": "scatter"
      },
      {
        "name": "No Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [30, 41, 74, 72],
        "mode": "markers",
        "type": "scatter"
      },
      {
        "name": "Start-up Risk",
        "x": ["Completed", "Delayed", "On Track", "Started"],
        "y": [8, 14, 22, 12],
        "mode": "markers",
        "type": "scatter"
      },
      { "name": "Enrollment - Risk", "x": ["Completed"], "y": [1], "mode": "markers", "type": "scatter" }
    ]
  }

]